//show all the oders and status also for particular UID

import React from 'react'
import withAuthorization from "./withAuthorization";
import { db } from "../firebase";
import {Card, CardText, CardTitle} from 'reactstrap';


class MyOders extends React.Component{
    state = {
        users: null,
        cart: "",
        loading: true,
        order_color: '#c9a0ff'
      };
    
      componentDidMount() {
        // db.onceGetUsers().then(res => {
        //   this.setState({
        //     users: res.val()
        //   });
        // });
    
        const { loggedUser } = this.props;
        db.doGetAnUnser(loggedUser.uid).once('value', snapshot => {
          this.setState({
            cart: snapshot.val().cart,
            loading: false
          });
        });
      }
    
      render() {
        const { users, cart, loading } = this.state; 
        // console.log(Object.values(cart))
        // Object.entries(cart).map(([key, value]) => {
        //     console.log("key......"+ key);
        //     console.log("value........"+ value.items);
        // })
        return (
          <div>
            {
                Object.entries(cart).map(([key, value]) => {
                  if(value.status==='pending'){
                    return(
                        <Card body inverse color='info' style={{marginBottom:'10px'}}>
                            <CardTitle>{key}</CardTitle><br/>
                            {value.items.map((a,i)=>{
                                return (
                                   <CardText>{a}</CardText>
                                )
                            })}
                            {`STATUS: ${value.status}`}<br/><br/>
                        </Card>
                        
                    )
                }

                else{
                  return(
                  <Card body inverse color='success' style={{marginBottom:'10px'}}>
                            <CardTitle>{key}</CardTitle><br/>
                            {value.items.map((a,i)=>{
                                return (
                                   <CardText>{a}</CardText>
                                )
                            })}
                            {`STATUS: ${value.status}`}<br/><br/>
                        </Card>
                  )
                }
                }
                )
                
            }
          </div>
        );
      }
    }

const authCondition = authUser => !!authUser;

export default withAuthorization(authCondition)(MyOders);